import React from 'react';
import { cn } from "@/utils/cn";
import { useTheme } from '@/app/providers/ThemeProvider';
import { DarkLogo, LightLogo } from '@/constants/images';

interface BrandLogoProps {
    className?: string;
    showAI?: boolean;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ className, showAI = true }) => {
    const { theme } = useTheme();

    return (
        <div className={cn("flex items-center", className)}>
            <img
                width={180}
                height={100}
                src={theme === "light" ? LightLogo : DarkLogo}
                alt="theQuickAssist.co"
                className="h-6 md:h-[2.1rem] w-auto transition-all"
            />
            {!showAI && <span className="sr-only">TheQuickAssist.co</span>}
        </div>
    );
};

export default BrandLogo;
